<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Monitor from "@/services/Monitor";
import ModalEditSocialLevel from "@/components/modals/social/modalEditSocialLevel";
import ModalAddSocialLevel from "@/components/modals/social/modalAddSocialLevel";
import Swal from "sweetalert2";

export default {
  components: {
    Layout,
    PageHeader,
    ModalEditSocialLevel,
    ModalAddSocialLevel,
  },
  page: {
    title: "Social Level",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      error: null,


      tableData: [],
      title: "Social Level",
      items: [
        {
          text: "Social",
        },
        {
          text: "Social Level",
          active: true,
        },
      ],
      filterInput: {},
      isBusy: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "valid_from",
      sortDesc: true,
      dealData: [],
      socialLevelData: [],
      fields: [
        {
          key: "level",
          label: "Level",
          visible: false,

        },
        {
          key: "required_points",
          label: "Required Points",
          visible: true,
        },
        {
          key: "description",
          label: "Description",
          visible: true,
        },
        {
          key: "Action",
          label: "Action",
        }
      ],
      statusOptions: [],
      isBusyAll: false,
      totalRowsAll: 0,
      currentPageAll: 1,
      perPageAll: 10,
      pageOptionsAll: [10, 25, 50, 100],
      filterAll: null,
      filterOnAll: [],
      filterData: false,


    };
  },

  async created() {
   await this.getSocialLevels();
  },
  methods: {


    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    async getSocialLevels() {

      try {
        this.filterData = true;
        this.isBusy = true;
        var filters = '';
        const response = await Monitor.getSocialLevels(filters);
        this.tableData = response.data.data
        this.totalRows = this.tableData.length
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        this.error = error.response.data.error ? error.response.data.error : "";
        this.tableData = []
        this.totalRows = 0
      }
    },

    callModalEditTeamDeal(data) {
      this.$bvModal.show("edit_social_level");
      this.socialLevelData = data
    },

    callModalAddSocialLevel(data) {
      this.$bvModal.show("add_social_level");
      this.socialLevelData = data
    },
    removeSocialLevel(level) {
      Swal.fire({
        title: "Are you sure?",
        text: "Remove From Social Level!", icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          Monitor.deleteSocialLevel(level)
              .then((response) => {
                const res = response.data.data ? response.data.data : false;
                const error = response.data.error ? response.data.error : '';
                if (res == '' && error == '') {
                  this.getSocialLevels();
                  this.successmsg("Social Level Successfully Removed")
                } else {
                  this.failedmsg("Social Level Removal Failed")
                }
              })
              .catch(error => {
                this.failedmsg('Fail!', error)
              });
        }
      });
    },


  },
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :fields="fields"/>
    <div class="row">
      <div class="col-12">

        <div class="card" v-show="filterData">
          <div class="card-body">
            <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light"
               @click="callModalAddSocialLevel">
              <i class="mdi mdi-plus me-2"></i>Add New Social Level
            </a>

            <div class="row mt-4">
              <div class="col d-inline-flex align-items-center">
                <h4 class="card-title m-0">Total Social Levels: {{ totalRows }}</h4>
              </div>
            </div>

            <div class="row mt-4" v-show="filterData">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="deals-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0 font-size-12" v-show="filterData">
              <b-table
                  :items="tableData"
                  :busy="isBusy"
                  :fields="fields"
                  :visible="fields.visible"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  show-empty
                  empty-text="No Data Found"
              >
                <template v-slot:cell(action)="data">
                  <ul class="list-inline mb-0 flo">
                    <li class="list-inline-item">
                      <a href="javascript:void(0);" class="px-2 text-primary" title="Edit Level"
                         @click="callModalEditTeamDeal(data.item)">
                        <i class="uil uil-pen font-size-18"></i>
                      </a>
                    </li>
                    <li class="list-inline-item">
                      <a href="javascript:void(0);" class="px-2 text-danger" title="Remove Level"
                         @click="removeSocialLevel(data.item.level)">
                        <i class="uil uil-trash-alt font-size-18"></i>
                      </a>
                    </li>
                  </ul>
                </template>

                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>

              </b-table>
            </div>
            <!--Table end -->

            <div class="row" v-show="filterData">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


    <!-- MODALS -->
    <ModalEditSocialLevel :socialLevelData="socialLevelData" @onRefresh="getSocialLevels()"></ModalEditSocialLevel>
    <ModalAddSocialLevel :socialLevelData="socialLevelData" @onRefresh="getSocialLevels();"></ModalAddSocialLevel>
    <!-- /MODALS -->

  </Layout>
</template>
